const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

module.exports.reportData = {
  info: {
    campaignName: 'Visit Britain 2017',
    influencerName: 'Alex French Guy Cooking',
    reportDate: new Date('2018-01-25'),
  },
  youtubeViews: 74922,
  youtubeEngagements: 4448,
  supportingActivity: [
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BZ8BMv7Bbmq/",
      "title": "Good MooOOoorning ! Hey, That's my hand right h...",
      reach: 11745,
      impressions: 16143,
      "views": null,
      "engagements": 910,
      "screenshot": "https://scontent-lhr3-1.cdninstagram.com/t51.2885-15/e35/22278186_1249459061826481_8241547701309669376_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BW-7bxKhDD5/",
      "title": "Getting my bag ready, cause I'm flying 🛫 to #no...",
      reach: 10607,
      impressions: 14836,
      "views": null,
      "engagements": 728,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/6ca8df29c1c37c3d4fedd5b480c91cde/5B24D2C1/t51.2885-15/e35/20225795_1155766401221850_4502342378773807104_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BXBp3c7hmgG/",
      "title": "#dryagedbeef #Ribeye 🍖 doesn't get any better. ...",
      reach: 10815,
      impressions: 15170,
      "views": null,
      "engagements": 993,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/1fdf0f7f014bbbd593cf1294860dabf3/5AE21253/t51.2885-15/e35/20347101_1889696551284796_2344707790318075904_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BXCqoInhD54/",
      "title": "Clearly not for the faint of heart. #goodmornin...",
      reach: 9157,
      impressions: 12674,
      "views": null,
      "engagements": 552,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/96d85f5fc82ee45372078f8109336cf6/5AEB3221/t51.2885-15/e35/20225953_1788228341468082_7589039261630857216_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BXDhBf7hVn2/",
      "title": "Lamb and smoked mozzarella, both local ☘️. So de...",
      reach: 8763,
      impressions: 11831,
      "views": null,
      "engagements": 590,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/d2346f8b96094b654e52e6fa247ce395/5ADD1910/t51.2885-15/e35/20394207_870928369750437_1847980026373341184_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BXGDr6XBHyL/",
      "title": "Inspiration comes from @pykenpommes_ today. So ...",
      reach: 9149,
      impressions: 11896,
      "views": null,
      "engagements": 624,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/72f02d00d3045b68cf0960fd6f3ac74a/5AEB5CB5/t51.2885-15/e35/20346980_1283586601738524_3138755395472850944_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BXGkqgBhnz2/",
      "title": "Mopping the sauce at @harrys_shack tonight. Cha...",
      reach: 10179,
      impressions: 13589,
      "views": 5147,
      "engagements": 5852,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/f8150c312088d3db5ac3e3052c988df8/5A6809A0/t51.2885-15/e15/20393738_1508575185874090_5886783769054019584_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BXH7ShlhsPB/",
      "title": "MoooOOOooornin' y'all. Went sea fishing 🚢 this ...",
      reach: 13493,
      impressions: 18441,
      "views": null,
      "engagements": 1582,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/9d1dd57912c9f11aef1e7ac4b879e1d8/5B00D581/t51.2885-15/e35/20394020_346886202398782_2581567170743894016_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BXJbTB1B15v/",
      "title": "Stumbled upon Game-Changing beers tonight made ...",
      reach: 8578,
      impressions: 11878,
      "views": null,
      "engagements": 449,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/f53a7ca3c8ad7ce5ef8605fc33cb7a4d/5B0045B5/t51.2885-15/e35/20481937_1887583028172664_3261077687560568832_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BXKnAHOhN8G/",
      "title": "Yes, please. Breakfast is needed. 😅\n-\nOui ! I a...",
      reach: 11076,
      impressions: 15065,
      "views": null,
      "engagements": 995,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/7137698672f43e1e973af0c471cb9df5/5B02583C/t51.2885-15/e35/20394265_137784620155422_1108024192827129856_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BXOJ3tah1Vu/",
      "title": "This is my flogging setup whenever I eat in a r...",
      reach: 9087,
      impressions: 12357,
      "views": null,
      "engagements": 550,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/a232ec42b15e8fe5ad28d47ba0ea7c3b/5AF39410/t51.2885-15/e35/20482642_851681208340497_7947643896698241024_n.jpg"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/p/BXqYZHeBtjL/",
      "title": "Few of many edible gifts I brought back from my...",
      reach: 8540,
      impressions: 11699,
      "views": null,
      "engagements": 531,
      "screenshot": "https://scontent-frt3-2.cdninstagram.com/vp/4a4ee1165b5670ffffd5ea646629a77c/5B250764/t51.2885-15/e35/20687083_265973463904884_3794644799047335936_n.jpg"
    },
    {
        "platform": "facebook",
        "url": "https://www.facebook.com/frenchguycooking/videos/1488233294628677/",
        "title": "I made an incredible 3 day Food Tour all accros...",
        "views": 1288,
        "engagements": 1363,
        "screenshot": "https://graph.facebook.com/1488233294628677/picture"
      },
    {
      "platform": "twitter",
      "url": "https://twitter.com/FrenchGuyCookin/status/890653771901960194",
      "title": "Dining at @oxbelfast tonight.spoiler alert : It...",
      "engagements": null
    },
    {
      "platform": "twitter",
      "url": "https://twitter.com/FrenchGuyCookin/status/890523780560424963",
      "title": "OMG. @SAWERSLTD in #Belfast is very unique. Sup...",
      "engagements": null
    },
    {
      "platform": "twitter",
      "url": "https://twitter.com/FrenchGuyCookin/status/916711086753239041",
      "title": "I spent 3 days eating and drinking everything N...",
      "engagements": null
    }
  ],

  heroData: {
    main: {
      title: 'Unique Food Experiences in Northern Ireland...',
      subTitle: 'I explore Northern Ireland, looking for the best food and drink experiences that beautiful country has to offer. Big thanks to the Tourist Board of Northern Ireland and to Visit Britain for making this whole adventure possible. For more inspiration go to http://po.st/8G7V7B',
      videoUrl: 'https://www.youtube.com/watch?v=E3maq9Bqe8Q',
      views: 74922,
      engagements: 4448,
      watchTimeUKIre: 124252,
      watchTimeTotal: 912546,
      donutData: {
        labels: [
          'female %',
          'male %',
        ],
        datasets: [{
          data: [24.2, 75.8],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.blue,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.bgBlue,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [{
            label: 'female %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [1, 8.7, 9.2, 2.6, 1.4, 0.7, 0.5],
          },
          {
            label: 'male %',
            backgroundColor: dyzioPalette.blue,
            borderColor: dyzioPalette.bgBlue,
            borderWidth: 1,
            data: [1.8, 21, 35.3, 10.9, 3.9, 1.4, 1.5],
          },
        ],
      },
      viewingData: [{
          name: 'United States',
          watchTime: 281921,
          views: 22166,
          likes: 1306,
        },
        {
          name: 'United Kingdom',
          watchTime: 109263,
          views: 9294,
          likes: 535,
        },
        {
          name: 'Germany',
          watchTime: 67807,
          views: 5195,
          likes: 364,
        },
        {
          name: 'Canada',
          watchTime: 62599,
          views: 4984,
          likes: 301,
        },
        {
          name: 'France',
          watchTime: 32780,
          views: 2812,
          likes: 164,
        },
      ],
    },
    supportingData: null
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report/data/afg-visit-britain-2017.js